import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import TabellaLista from "../../../components/Tabella/TabellaLista";
import MyApiClient from "../../../../api-client/MyApiClient";
import { format } from 'date-fns';
import { dateTimeSort } from "../../../components/Util/oders";

export const DocumentsTable = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const MAX_FILE_SIZE = 5 * 1024 * 1024;
	const ALLOWED_FILE_TYPES = ['application/pdf'];

	const [newDocName, setNewDocName] = useState('');
  	const [newDocFile, setNewDocFile] = useState(null);

	const [data_json, setDataJson] = useState(null);
	const [ricarica, setRicarica] = useState(0);

	// Dentro "La mia struttura" basta ricaricare l'elenco; dalla pagina a se' si
	// torna alla scheda documenti de "La mia struttura", come prima.
	const aggiornaDopoModifica = () => {
		if (location.pathname.startsWith('/struttura/lamiastruttura')) {
			setRicarica((n) => n + 1);
		} else {
			navigate('/struttura/lamiastruttura?tab=documenti');
		}
	};
	const [modalCentered, setModalCentered] = useState(false);

	const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

	const [loadingShowed, setLoadingShowed] = useState(false);
	const handleTextChange = (event) => {
		setNewDocName(event.target.value);
	};

	const handleFileChange = (event) => {
		setNewDocFile(event.target.files[0]);
	};

	// La riga apre la scheda del documento (pagina, non più finestra): anteprima, «Scarica» ed «Elimina» stanno lì (03/10/2026)
	const apriDocumento = (row) => {
		const from = location.pathname.startsWith('/struttura/lamiastruttura') ? '/struttura/lamiastruttura?tab=documenti' : '/struttura/documenti';
		navigate('/struttura/documenti/scheda/' + row.id, { state: { documento: row, from } });
	};

	const addDoc = (e) => {
        e.preventDefault();

		setModalCentered(false);

		let file = newDocFile;

		if (file) {

			if (file.size > MAX_FILE_SIZE) {
				setModalTitle("Errore durante l'operazione");
				setModalText('Il file selezionato supera la dimensione massima consentita.');
				setModalShowed(true);
				return;
			}

			if (!ALLOWED_FILE_TYPES.includes(file.type)) {
				setModalTitle("Errore durante l'operazione");
				setModalText('Il file selezionato non è di tipo PDF.');
				setModalShowed(true);
				return;
			}

			const reader = new FileReader();
			reader.onloadend = () => {
				const base64String = reader.result.split(',')[1];
				// console.log(base64String);
				continueAddDoc(newDocName,base64String);
			};
			reader.readAsDataURL(file);
		}
    };

	function continueAddDoc(newDocName,base64String) {
		//console.log(newDocName);
		//console.log(base64String);

		const addData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					let data_insert = {
						'content': base64String,
						'name': newDocName
					}
					
					setLoadingShowed(true);
                    const saveResult = await apiClient.addDocument(token, data_insert);
					setLoadingShowed(false);

					if (saveResult && saveResult.error) {
						setModalTitle("Errore durante l'operazione");
						setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
						setModalShowed(true);
					} else {
						setNewDocName('');
						setNewDocFile(null);
						aggiornaDopoModifica();
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        addData();
	}

	const data_column = [
		{
			Header: 'Data caricamento',
			Footer: 'Data caricamento',
			accessor: 'data-caricamento',
			disableGlobalFilter: true,
			sortType: dateTimeSort,
		},
		{
			Header: 'Nome documento',
			Footer: 'Nome documento',
			accessor: 'nome-documento',
		},
	];

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [documentsData] = await Promise.all([
                        apiClient.getDocuments(token)
                    ]);
					setLoadingShowed(false);

					if(documentsData) {
						let data_requests = [];
						documentsData.forEach(element => {
							let member_row = {
								"id": element.id,
								"data-caricamento": format(element.uploadedAt, 'dd/MM/yyyy HH:mm:ss'),
								"nome-documento": element.name,
								"uri": element.uri
							};
							data_requests.push(member_row);
						});
						setDataJson(data_requests);
					} else {
						setDataJson([]);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, [ricarica]);

	return (

		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<TabellaLista
				pageList={true}
				openColumn={'nome-documento'}
				openRow={(row) => apriDocumento(row)}
				cardTitle={'Documenti'}
				hasSearch={true}
				searchPlaceholder={'Cerca per nome documento'}
				hasFilter={false}
				hasAddMoreAsModal={true}
				modalCallBack={() => setModalCentered(true)}
				modalContent={
					<Modal className="fade" show={modalCentered} centered>
						<Modal.Header>
							<Modal.Title>Aggiungi documento</Modal.Title>
							<Button
								onClick={() => setModalCentered(false)}
								variant=""
								className="btn-close"
							>
							</Button>
						</Modal.Header>
						<Modal.Body>
							<Form>
								<Row>
									<Col className="col-lg-12 pb-4">
										<Form.Label>Nome del documento</Form.Label>
										<Form.Control type="text" placeholder="Inserisci il nome del documento" onChange={handleTextChange} />
									</Col>
								</Row>
								<Row>
									<Col className="col-lg-12 pb-4">
										<Form.Label>Seleziona file</Form.Label>
										<Form.Control type="file" placeholder="Carica il file" onChange={handleFileChange} />
									</Col>
								</Row>
							</Form>
						</Modal.Body>
						<Modal.Footer className="justify-content-between">
							<Button className="btn btn-light btn-add" onClick={() => setModalCentered(false)}>
								Annulla
							</Button>
							<Button onClick={addDoc} className="btn btn-primary btn-add">Aggiungi</Button>
						</Modal.Footer>
					</Modal>
				}
				data_column={data_column}
				data_json={data_json}
				sort_by={'data-caricamento'}
                sort_type={'desc'}
			/>
		</>
	)
}

export default DocumentsTable;
